import { render } from "./Upload.vue?vue&type=template&id=0dce24ec&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=0dce24ec&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dce24ec"]])

export default __exports__